export var API_KEY = 'AIzaSyAfD03wWQTjki7w5rpBdG5KL1S-AIqsICQ';
